import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const ScheduleBeneficiaryMultiApprovalDeclined = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);

  const buttonRows = [
    [
      {
        btnText: "Reject more schedules",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/beneficiary_transaction_dashboard/schedule_multi_approval",
            {
              replace: true,
            },
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () =>
          navigate("/beneficiary_transaction_dashboard", {
            replace: true,
          }),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
              {
                replace: true,
              },
            )
          }
          rows={[
            {
              leftTitle: account?.scheduled_name,
              leftSubTitle: "Schedule name",

              rightTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              hasRight: true,
              rightIcon: true,
              rightText: true,
              onClick: () =>
                navigate(
                  `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
                  {
                    replace: true,
                  },
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedscheduleData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={declinedPageID?.length && "Schedules rejected successfully."}
    >
      <TabsWeapperSection
        title={`Rejected Schedules - ${
          declinedPageID?.length || declinedPageData?.length
        }`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ScheduleBeneficiaryMultiApprovalDeclined;
